<template>
  <div class="container-principal" :class="componenteAtual">
    <div style="width: 100%">
      <component
        :is="componenteAtual"
        :dados="dados"
        @dados-etapa="handleDadosEtapa"
        @proxima-etapa="proximo"
        @etapa-anterior="anterior"
      />
    </div>
  </div>
</template>

<script>
import Etapa1 from './Etapa1.vue'
import Etapa2 from './Etapa2.vue'
import Etapa3 from './Etapa3.vue'
import Etapa4 from './Etapa4.vue'
import Etapa5 from './Etapa5.vue'
import Etapa6 from './Etapa6.vue'
import Etapa7 from './Etapa7.vue'
import Etapa8 from './Etapa8.vue'
import Etapa9 from './Etapa9.vue'
import Etapa10 from './Etapa10.vue'

export default {
  metaInfo: {
    title: 'eSUS Feedback - Cofinanciamento Simulação',
    titleTemplate: null,
  },
  components: {
    Etapa1,
    Etapa2,
    Etapa3,
    Etapa4,
    Etapa5,
    Etapa6,
    Etapa7,
    Etapa8,
    Etapa9,
    Etapa10,
  },
  data() {
    return {
      dados: {
        etapa1: null,
        etapa2: null,
        etapa3: null,
        etapa4: null,
        etapa5: null,
        etapa6: null,
        etapa7: null,
        etapa8: null,
        etapa9: null,
        etapa10: null,
      },
      etapaAtual: 1,
    }
  },
  computed: {
    componenteAtual() {
      return 'Etapa' + this.etapaAtual
    },
  },
  methods: {
    handleDadosEtapa({ etapa, dados }) {
      this.dados[etapa] = dados
    },
    proximo() {
      if (this.etapaAtual === 10) {
        return
      }
      this.etapaAtual++
    },
    anterior() {
      if (this.etapaAtual > 0) {
        this.etapaAtual--
      }
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
